module.exports = __webpack_public_path__ + "4bbce871335ba3865c9be8f1bb07abf2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-23.png
// module id = 2134
// module chunks = 0